import Chip from "@mui/material/Chip";
import { AutocompleteInput } from "@sinch/components/form/AutocompleteInput/AutocompleteInput";
import { AutocompleteOptions } from "@sinch/components/form/AutocompleteInput/types";
import { useFormat } from "@sinch/core/hooks/format";
import { t } from "i18next";

import { isEmpty, pluck } from "ramda";

type RecipientsOptions = AutocompleteOptions;

interface RecipientsInputProps {
  recipients: { name: string; phone: string }[];
  loading?: boolean;
}

export const RecipientsInput = ({ recipients, loading }: RecipientsInputProps) => {
  const { phone } = useFormat();
  const options = recipients.map((recipient) => ({
    label: recipient.name,
    value: recipient.phone,
    option: (
      <>
        {recipient.name} [{phone.national(recipient.phone)}]
      </>
    ),
  }));

  return (
    <AutocompleteInput<RecipientsOptions, true>
      disabled={isEmpty(recipients)}
      error={isEmpty(recipients)}
      errorMessage={isEmpty(recipients) ? [t("Messages.noAvailableRecipients")] : undefined}
      getOptionLabel={(option) => option.label}
      inputReadOnly
      label={t("Messages.recipientsInputLabel")}
      loading={loading}
      multiple
      openOnFocus
      options={options}
      readOnly
      renderTags={(vals, getTagProps) =>
        vals.map(({ value, option }, index) => (
          <Chip {...getTagProps({ index })} key={value || index} label={option} variant="filled" />
        ))
      }
      skeleton={loading}
      value={pluck("value", options)}
    />
  );
};
